export const getLogoByLanguage = (language: string): string => {
  const logos: { [key: string]: string } = {
    finnish: '/main_fi.jpg',
    english: '/main_en.jpg',
    swedish: '/main_sv.jpg'
  };
  return logos[language] || logos.finnish;
};